import script from "./EditProductStatusLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProductStatusLog.vue?vue&type=script&setup=true&lang=ts"

import "./EditProductStatusLog.vue?vue&type=style&index=0&id=7471633c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7471633c"]])

export default __exports__